import React from "react";

const RefundPolicy = () => {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "30px 20px",
        lineHeight: "1.7",
        color: "#333",
        textAlign: "left",
      }}
    >
      <h1
        style={{
          marginBottom: "20px",
          fontSize: "2rem",
          color: "#222",
          fontWeight: "600",
          textAlign: "left",
        }}
      >
        Cancellation & Refund Policy – Speak Bold with KK
      </h1>

      <p>
        Speak Bold with KK offers monthly subscription-based digital learning
        services. Please note that <strong>all payments are non-refundable </strong>
        once the subscription for a month is purchased.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          fontWeight: "500",
          textAlign: "left",
        }}
      >
        Subscription Payments
      </h2>
      <p>
        Users are billed monthly for access to our premium content and online
        sessions. Ensure that you review the subscription details before
        completing payment.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          fontWeight: "500",
          textAlign: "left",
        }}
      >
        No Refund Policy
      </h2>
      <p>
        Once a subscription payment is made for the current month, it cannot be
        refunded under any circumstances. Please plan your subscription usage
        accordingly.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          fontWeight: "500",
          textAlign: "left",
        }}
      >
        Contact for Payment Queries
      </h2>
      <p>
        If you have any questions or concerns regarding your subscription, you
        can reach us at:
      </p>

      <p>
        <strong>Email:</strong> support@speakboldwithkk.com
      </p>
    </div>
  );
};

export default RefundPolicy;
